import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthStateService } from "../services/auth-state.service";

/**
 * Guard para rutas protegidas.
 * Con APP_INITIALIZER, la restauración silenciosa de sesión ya ocurrió antes
 * de la primera navegación, por lo que aquí basta validar estado actual.
 */
export const authGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (authState.isAuthenticated()) {
    return true;
  }

  const returnUrl = state.url?.startsWith("/") ? state.url : "/home";

  return router.createUrlTree(["/login"], {
    queryParams: { returnUrl },
  });
};
